/**
 * @fileoverview Shared token refresh logic used by both axios interceptors and fetch wrappers.
 */

import { redirectToPlatformLoginPageWithReturn } from '@/lib/api/platform/redirect.utils';
import PlatformApiSdk from '@monksflow/platform-api-sdk';

let refreshTokenPromise: Promise<unknown> | null = null;

/**
 * Attempts to refresh the auth token.
 * Concurrent 401s share a single refresh promise. On failure, all callers
 * redirect (harmless - browser navigates once).
 */
export async function attemptTokenRefresh(): Promise<boolean> {
  try {
    if (!refreshTokenPromise) {
      refreshTokenPromise = PlatformApiSdk.refreshToken();
    }

    await refreshTokenPromise;
    return true;
  } catch {
    redirectToPlatformLoginPageWithReturn();
    return false;
  } finally {
    refreshTokenPromise = null;
  }
}
